import Vue from 'vue'
import Vuex from 'vuex'

import orgStore from './modules/orgStore'
import multTabStore from './modules/multTabStore'
import enumsStore from './modules/enumsStore'
import sysRepeatDataStore from './modules/sysRepeatDataStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // lang: sessionStorage.getItem('lang') || 'zh_CN',
    lang: localStorage.getItem('lang') || 'zh_CN',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || null
  },
  mutations: {
    changeLang(state, lang) {
      state.lang = lang
      localStorage.setItem('lang', lang)
      if (lang === 'zh_CN') {
        document.title = '智能门禁系统'
      }
      if (lang === 'en_US') {
        document.title = 'Intelligent ACS'
      }
    },

    refreshUserInfo(state, userData) {
      state.userInfo = userData
      if (userData) {
        sessionStorage.setItem('userInfo', JSON.stringify(userData))
      } else {
        sessionStorage.removeItem('userInfo')
      }
    }
  },
  actions: {},
  modules: {
    orgStore,
    multTabStore,
    enumsStore,
    sysRepeatDataStore
  }
})
